<div class="settings-page">
  <div class="page-title">
    <h2 class="title">Settings</h2>
  </div>

  <div class="container delete-account">
    <div class="description">
      <div class="des-header">Delete my Developer Console Account</div>
      <div class="des-body">
        This action will delete all the data from the Developer Console and unlink your Samsung Account. (Your Samsung
        Account will stay intact.)
      </div>
    </div>

    <sdc-design-button
      type="warn"
      outline="true"
      [title]="'Delete my account'"
      width="180px"
      height="40px"
      (click)="deleteConfirm()"
    ></sdc-design-button>
  </div>
</div>

<ng-template #deleteWarning>
  <a class="close" [mat-dialog-close]>
    <img class="close-icon" src="/assets/images/icons/close-icon.png" alt="close-icon" />
  </a>
  <div>
    <div class="warning-head">Your account can not be deleted at this time!</div>
    <div class="warning-body">
      {{ errMessage }}
    </div>
    <div class="warning-footer">
      <sdc-design-button
        type="primary"
        [title]="'Back'"
        width="150px"
        height="40px"
        (click)="closeDeleteWarning()"
      ></sdc-design-button>

    </div>
  </div>
</ng-template>
